import { render } from "./TimeTableHeader.vue?vue&type=template&id=150dd40a"
import script from "./TimeTableHeader.vue?vue&type=script&lang=ts"
export * from "./TimeTableHeader.vue?vue&type=script&lang=ts"
script.render = render

export default script